import { formatMoney } from '@theme/utilities';
import { ThemeEvents, CartUpdatedEvent } from '@theme/events';

class ProductForm extends HTMLElement {
 
constructor() {
  super();
  this.form = null;
  this.addToCartButton = null;
  this.addToCartButtonContainer = null;
  this.addToCartBehavior = null;
  this.toggleCrossSells = null;
  this.quantityBreaks = null;
  this.quantitySelectorInput = null;
}
connectedCallback() {
  this.form = this.querySelector('form[action$="/cart/add"]');
  this.addToCartButton = this.querySelector('[data-ref="add-to-cart-button"]');
  this.addToCartButtonContainer = this.querySelector('[data-ref="add-to-cart-button-container"]');
  this.addToCartBehavior = document.querySelector('cart-icon')?.addToCartBehavior || 'open_cart';
  this.toggleCrossSells = this.querySelector('[data-ref="toggle-cross-sells"]');
  this.quantityBreaks = this.querySelector('[data-ref="quantity-breaks"]');
  this.quantitySelectorInput = this.querySelector('[data-ref="product-quantity-selector"] input[name="quantity"]');

  this.form.addEventListener('submit', this.handleSubmit.bind(this));
  this.addEventListener(ThemeEvents.variantSelected, this.onVariantSelected.bind(this));
  this.addEventListener(ThemeEvents.variantUpdated, this.onFormUpdated.bind(this));
  document.addEventListener(ThemeEvents.toggleCrossSellsUpdated, this.onFormUpdated.bind(this));
  document.addEventListener(ThemeEvents.quantityBreaksUpdated, this.onFormUpdated.bind(this));
  this.quantitySelectorInput?.addEventListener('change', this.onFormUpdated.bind(this));

  this.patchSelectionRoot = this.closest('[id^="shopify-section-"]');

  if (!this.patchSelectionHandler) {
    this.patchSelectionHandler = (event) => {
      if (event.target.matches('[data-kids-patch-checkbox]')) {
        this.onFormUpdated();
      }
    };
  }

  this.patchSelectionRoot?.addEventListener(
    'change',
    this.patchSelectionHandler
  );

  this.embroideryRoot =
    this.closest('[id^="shopify-section-"]') || this;

  if (!this.embroideryChangeHandler) {
    this.embroideryChangeHandler = (event) => {
      if (event.target.matches('input, select')) {
        this.onFormUpdated();
      }
    };
  }

  this.embroideryRoot.addEventListener(
    'change',
    this.embroideryChangeHandler
  );
}

disconnectedCallback() {
  this.form.removeEventListener('submit', this.handleSubmit.bind(this));
  this.removeEventListener(ThemeEvents.variantSelected, this.onVariantSelected.bind(this));
  this.removeEventListener(ThemeEvents.variantUpdated, this.onFormUpdated.bind(this));
  document.removeEventListener(ThemeEvents.toggleCrossSellsUpdated, this.onFormUpdated.bind(this));
  document.removeEventListener(ThemeEvents.quantityBreaksUpdated, this.onFormUpdated.bind(this));
  this.quantitySelectorInput?.removeEventListener('change', this.onFormUpdated.bind(this));

  this.patchSelectionRoot?.removeEventListener(
    'change',
    this.patchSelectionHandler
  );

  this.embroideryRoot?.removeEventListener(
  'change',
  this.embroideryChangeHandler,
  true
);

}


  onVariantSelected() {
    this.addToCartButton.disabled = true;
  }

  onFormUpdated(event) {
    // On récupère le DOM actuel du composant
    const addToCartButtonContainer = this.addToCartButtonContainer;

    // Le event.detail est null si l'évenement de mise à jour est déclenché par les cross-sells à activer et non par les variantes, dans ce cas là on utilise le DOM actuel
    let newAddToCartButtonContainer = addToCartButtonContainer;
    if (event && event.detail != null) {
      newAddToCartButtonContainer = event.detail.data.html.querySelector('[data-ref="add-to-cart-button-container"]');
    }

    if (!newAddToCartButtonContainer || !addToCartButtonContainer) return;

    // On remplace le DOM actuel par le nouveau DOM
    if (addToCartButtonContainer !== newAddToCartButtonContainer) {
      addToCartButtonContainer.replaceWith(newAddToCartButtonContainer);
    }

    // On réassigne les nouvelles valeurs du bouton pour le reste du fonctionnement du composant
    this.addToCartButton = newAddToCartButtonContainer.querySelector('[data-ref="add-to-cart-button"]');
    this.addToCartButtonContainer = newAddToCartButtonContainer;

    // On récupère les prix totaux du formulaire (incluant le produit de base, sa quantité, les cross-sells à activer, etc.)
    const newTotalPrice = this.getCurrentTotalPrice().price;
    const newTotalCompareAtPrice = this.getCurrentTotalPrice().compare_at_price;

    // On met à jour les prix dans le nouveau DOM à insérer
    const priceElement = this.addToCartButtonContainer.querySelector('[data-ref="price"]');
    if (priceElement != null) {
      priceElement.innerHTML = formatMoney(newTotalPrice);
    }

    const compareAtPriceElement = this.addToCartButtonContainer.querySelector('[data-ref="compare-at-price"]');
    if (compareAtPriceElement != null) {
      compareAtPriceElement.innerHTML = '';
      if (newTotalCompareAtPrice > newTotalPrice) {
        compareAtPriceElement.innerHTML = formatMoney(newTotalCompareAtPrice);
      }
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    this.addToCartButton.classList.add('is-loading');

    let items = [];

    const hasItemsInputs = this.form?.querySelector('input[name^="items["], select[name^="items["], textarea[name^="items["]') !== null;

    // Cas avec plusieurs produits avec format items[0][id], items[0][quantity], items[0][properties][color] (parfois utilisé par des applications de bundle et autre)
    if (hasItemsInputs) {
      const itemsData = {};

      this.form.querySelectorAll('input[name^="items["], select[name^="items["], textarea[name^="items["]').forEach((input) => {
        const name = input.name;

        // Extraire l'index: items[0] -> 0
        const indexMatch = name.match(/items\[(\d+)\]/);
        if (!indexMatch) return;

        const index = indexMatch[1];

        // Créer l'objet pour cet index s'il n'existe pas
        if (!itemsData[index]) {
          itemsData[index] = {};
        }

        // Déterminer quel champ on traite
        if (name.includes('[id]')) {
          itemsData[index].id = input.value;
        } else if (name.includes('[quantity]')) {
          itemsData[index].quantity = parseInt(input.value, 10) || 1;
        } else if (name.includes('[selling_plan]')) {
          // Support des abonnements (selling plans) pour chaque item
          if (input.value) {
            itemsData[index].selling_plan = input.value;
          }
        } else if (name.includes('[properties]')) {
          // Extraire le nom de la propriété: items[0][properties][color] -> color
          const propertyMatch = name.match(/\[properties\]\[([^\]]+)\]/);
          if (propertyMatch) {
            if (!itemsData[index].properties) {
              itemsData[index].properties = {};
            }
            itemsData[index].properties[propertyMatch[1]] = input.value;
          }
        }
      });

      // Convertir l'objet en array
      for (const key in itemsData) {
        items.push(itemsData[key]);
      }
    }

    if (this.quantityBreaks) {
      items = [...items, ...this.quantityBreaks.getSelectedItems()];
    } else {
      const properties = {};

      this.form.querySelectorAll('input[name^="properties["], select[name^="properties["], textarea[name^="properties["]').forEach((input) => {
        const propertyKey = input.name.replace('properties[', '').replace(']', '');
        properties[propertyKey] = input.value;
      });

      const item = {
        id: this.form.querySelector('input[name="id"]').value,
        quantity: parseInt(this.form.querySelector('input[name="quantity"]')?.value, 10) || 1,
      };

      // Ajouter les properties seulement s'il y en a
      if (Object.keys(properties).length > 0) {
        item.properties = properties;
      }

      // Support des abonnements (selling plans)
      const sellingPlanInput = this.form.querySelector('input[name="selling_plan"], select[name="selling_plan"]');
      if (sellingPlanInput?.value) {
        item.selling_plan = sellingPlanInput.value;
      }

      items.push(item);
    }

    if (this.toggleCrossSells) {
      items = [...items, ...this.toggleCrossSells.getSelectedItems().items];
    }
    const productSection = this.closest('[id^="shopify-section-"]');

if (productSection) {
  const selectedPatches = productSection.querySelectorAll(
    '[data-kids-patch-checkbox]:checked:not(:disabled)'
  );

  const addedVariantIds = new Set(
    items.map((item) => String(item.id))
  );

  selectedPatches.forEach((checkbox) => {
    const variantId = checkbox.dataset.variantId;

    if (/^\d+$/.test(variantId || '') &&
        !addedVariantIds.has(variantId)) {
      items.push({
        id: variantId,
        quantity: 1
      });

      addedVariantIds.add(variantId);
    }
  });
}
    let quantity = items.reduce((acc, item) => acc + item.quantity, 0);

    const sections = [];
    if (document.querySelector('cart-drawer')) {
      sections.push(document.querySelector('cart-drawer').dataset.sectionId);
    }

    fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: items,
        sections: sections.join(','),
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        const currentItemCount = document.querySelector('cart-icon')?.getCurrentItemCount();
        // Attention à bien revoir ca
        const itemCountToAdd = quantity || 1;

        let newItemCount;
        if (currentItemCount != null) {
          newItemCount = currentItemCount + itemCountToAdd;
        }

        // On dispatch l'événement de mise à jour du panier
        document.dispatchEvent(
          new CartUpdatedEvent(
            {},
            {
              itemCount: newItemCount,
              source: 'product-form',
              sections: response.sections,
            },
          ),
        );

        this.addToCartButton.classList.remove('is-loading');
      })
      .then(() => {
        if (this.addToCartBehavior == 'notification') {
          document.dispatchEvent(
            new CustomEvent('toast:open', {
              detail: { type: 'success', message: Theme.translations.addToCartNotificationMessage },
            }),
          );
        }
      })
      .catch((error) => {
        console.error('Error:', error);
        document.dispatchEvent(
          new CustomEvent('toast:open', {
            detail: { type: 'error', message: error },
          }),
        );
      });
  }

  // Permet de récupérer les prix totaux du formulaire (incluant le produit de base, sa quantité, les cross-sells à activer, etc.)
  getCurrentTotalPrice() {
    let newPrice = parseInt(this.addToCartButtonContainer.dataset.price);
    let newCompareAtPrice = newPrice;
    if (this.addToCartButtonContainer.dataset.compareAtPrice) {
      newCompareAtPrice = parseInt(this.addToCartButtonContainer.dataset.compareAtPrice);
    }

    if (this.quantityBreaks) {
      newPrice = parseInt(this.quantityBreaks.getPrices().price);
      newCompareAtPrice = parseInt(this.quantityBreaks.getPrices().compareAtPrice);
    } else if (this.quantitySelectorInput) {
      const quantity = this.quantitySelectorInput.value;
      newPrice = newPrice * quantity;
      newCompareAtPrice = newCompareAtPrice * quantity;
    }

    if (this.toggleCrossSells) {
      newPrice += parseInt(this.toggleCrossSells.getSelectedItems().total_price);
      newCompareAtPrice += parseInt(this.toggleCrossSells.getSelectedItems().total_compare_at_price);
    }

const patchRoot = this.closest('[id^="shopify-section-"]');
const countedPatchIds = new Set();

patchRoot?.querySelectorAll(
  '[data-kids-patch-checkbox]:checked:not(:disabled)'
).forEach((checkbox) => {
  const variantId = checkbox.dataset.variantId;
  const patchPrice = Number(checkbox.dataset.price);

  if (!countedPatchIds.has(variantId) &&
      Number.isFinite(patchPrice)) {
    newPrice += patchPrice;
    newCompareAtPrice += patchPrice;
    countedPatchIds.add(variantId);
  }
});
// Supplément broderie : NON = 0 €, OUI = 12 €.
const embroideryRoot =
  this.closest('[id^="shopify-section-"]') || this;

const embroideryFields = Array.from(
  embroideryRoot.querySelectorAll('select')
).filter((select) => {
  const choices = Array.from(select.options).map((option) =>
    option.textContent.trim()
  );

  return (
    choices.some((text) => /^non$/i.test(text)) &&
    choices.some((text) =>
      /^oui\b/i.test(text) && /12[,.]00/.test(text)
    )
  );
});


const embroideryYes = Array.from(embroideryFields).some((field) => {
  if (field.disabled) return false;

  if (
    field instanceof HTMLInputElement &&
    ['radio', 'checkbox'].includes(field.type) &&
    !field.checked
  ) {
    return false;
  }

  const selectedText = field instanceof HTMLSelectElement
    ? field.selectedOptions[0]?.textContent || ''
    : Array.from(field.labels || [])
        .map((label) => label.textContent)
        .join(' ');

  return [field.value, selectedText].some((text) =>
    /^oui\b/i.test(String(text).trim())
  );
});

if (embroideryYes) {
  newPrice += 1200;
  newCompareAtPrice += 1200;
}
    const differencePrice = newCompareAtPrice - newPrice;
    return {
      price: newPrice,
      compare_at_price: newCompareAtPrice,
      difference_price: differencePrice,
    };
  }
}

if (!customElements.get('product-form')) {
  customElements.define('product-form', ProductForm);
}
